// extracted by mini-css-extract-plugin
export default {"link":"PersonGoBack_link__cRDvq","link__img":"PersonGoBack_link__img__AeFbI"};